import {
  GET_WELFARE_REGIMES
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_WELFARE_REGIMES] (state, data) {
    state.all = data
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/welfareRegimes.js